import { PageHeader } from '@/components/layout/PageHeader'

export function AgentsListPage() {
  return (
    <div className="flex flex-col gap-8 p-8">
      <PageHeader title="View and manage your AI agents" />
    </div>
  )
}
